import { render } from "./JobPostComponent.vue?vue&type=template&id=4f791d78"
import script from "./JobPostComponent.vue?vue&type=script&lang=js"
export * from "./JobPostComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__